
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".519","y":".379","width":"15.243","height":"15.243","rx":"7.621","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.171 4.97a.75.75 0 010 1.06l-5 5a.75.75 0 01-1.06-1.06l5-5a.75.75 0 011.06 0z","fill":"#313131"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.171 11.03a.75.75 0 01-1.06 0l-5-5a.75.75 0 111.06-1.06l5 5a.75.75 0 010 1.06z","fill":"#313131"}}),_c('rect',{attrs:{"x":".519","y":".379","width":"15.243","height":"15.243","rx":"7.621","stroke":"#FFB12E","stroke-width":".757"}})])
          )
        }
      }
    